// @ts-expect-error not yet migrated
import { getCanSave } from 'page-editor-ui/redux/selectors/saveSelectors';
export const getHasPermissionsToSaveEditor = state => {
  return getCanSave(state);
};